import React from 'react';
import FormLocalidades from '../../components/forms/formLocalidades';

const NewUbicacion = (props) => {
    return (
        <FormLocalidades/>
    );
}
 
export default NewUbicacion;